export class StudentInterviewVideoModal {
  constructor() {
    this.badge = document.querySelector('.js-video-badge')
    this.modal = document.querySelector('.js-video-modal')

    // 対象要素が存在しないページでは何もしない
    if (!this.badge || !this.modal) return

    this.overlay = this.modal.querySelector('.js-video-modal-overlay')
    this.closeBtn = this.modal.querySelector('.js-video-modal-close')
    this.iframe = this.modal.querySelector('iframe')

    if (this.iframe) {
      // autoplay=1 を付与したURLを保存し、初期srcは空にしておく
      // → サムネイルが表示されないため画質問題が回避でき、モーダルを開くたびに最初から自動再生される
      const url = new URL(this.iframe.src)
      url.searchParams.set('autoplay', '1')
      this._autoplaySrc = url.toString()
      this.iframe.src = ''
    }

    this._bindEvents()
  }

  _bindEvents() {
    this.badge.addEventListener('click', () => this._open())
    this.overlay?.addEventListener('click', () => this._close())
    this.closeBtn?.addEventListener('click', () => this._close())

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this._close()
    })
  }

  _open() {
    // モーダルを開くと同時にautoplayで再生開始
    if (this.iframe) this.iframe.src = this._autoplaySrc

    this.modal.classList.add('is-open')
    this.modal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('is-modal-open')
  }

  _close() {
    if (!this.modal.classList.contains('is-open')) return

    // srcをクリアして動画を停止する
    if (this.iframe) this.iframe.src = ''

    this.modal.classList.remove('is-open')
    this.modal.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('is-modal-open')
  }
}
